import { useContext } from 'react';
import { I18nLoaderContext } from '../internal/I18nLoaderContext';
export function useI18nLoader() {
  const i18nloader = useContext(I18nLoaderContext);
  if (!i18nloader) {
    throw new Error('i18nloader is required to render this card');
  }
  return i18nloader;
}